import {Box, IconButton, MenuItem, TableCell, TableRow, TextField} from "@mui/material";
import {IconTrash} from "@tabler/icons-react";
import {ProjectRoles} from "../../../../context/AppContext";

export const ProjectMemberItem = ({member, setMembers}) => {


  const handleRemove = () => {
    setMembers(prev => prev?.filter(i => i?.username !== member?.username));
  }

  const handleChange = (key, value) => {
    setMembers(prev => prev?.map(i => i?.username === member?.username ? {...i, [key]: value} : {...i}));
  }

  return (
    <>
      <TableRow hover>
        <TableCell padding={"checkbox"} sx={{fontWeight: 400, px: 2}}>{member?.username}</TableCell>
        <TableCell padding={"checkbox"} sx={{fontWeight: 400, px: 2, py: 1}}>
          <TextField
            size={"small"}
            placeholder={"VDN (Transfer Number)"}
            value={member?.vdn}
            sx={{minWidth: "150px", maxWidth: "250px", width: "100%"}}
            onChange={e => handleChange("vdn", e?.target?.value)}
          />
        </TableCell>
        <TableCell padding={"checkbox"} sx={{fontWeight: 400, px: 2, py: 1}}>
          <TextField
            select size={"small"}
            value={member?.role}
            sx={{minWidth: "150px", maxWidth: "250px", width: "100%"}}
            onChange={(e) => handleChange("role", e.target.value)}
          >
            {Object.entries(ProjectRoles).map(([key, value]) => (
              <MenuItem key={key} value={value}>{value?.toLowerCase()}</MenuItem>
            ))}
          </TextField>
        </TableCell>
        <TableCell padding={"checkbox"} sx={{fontWeight: 400, px: 2, py: 0.5}}>
          <Box sx={{ml: 'auto', textAlign: "end"}}>
            <IconButton onClick={handleRemove} sx={{ml: 'auto'}}>
              <IconTrash/>
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
    </>
  )
}